import React from 'react';

interface Props {
    className?: string;
}

export const EditIcon: React.FC<Props> = ({ className }) => {
    return (
        <svg className={`icon${className ? ` ${className}` : ''}`} width="20" height="20" viewBox="0 0 20 20">
            <path
                d="M7.6,15c0.3,0,0.5-0.1,0.7-0.3l8.6-8.6c0.8-0.8,0.8-2,0-2.7l-2.7-2.7c-0.8-0.8-2-0.8-2.7,0L2.8,9.2
			C2.6,9.4,2.5,9.6,2.5,9.9l0,5.1L7.6,15z M2.5,20l15,0v-2h-15L2.5,20z"
            />
        </svg>
    );
};
